import { useContext } from "react";
import { defaultTo } from "lodash/fp";
import { displayModeContext } from "../contexts/display-mode-context/display-mode-context.es.js";
import "../contexts/global-edit-context/global-edit-context.es.js";
import "../contexts/toast-context/toast-context.es.js";
function useDisplayMode(displayModeProp) {
  return defaultTo(useContext(displayModeContext), displayModeProp);
}
export {
  useDisplayMode
};
